(function () {
  var data = window.gaPageData || {};
  var currency = data.currency || 'INR';

  function gtrack(eventName, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', eventName, params || {});
  }

  // ── PAGE-TYPE EVENTS (fire on load) ────────────────────────────────────────

  // Product page
  if (data.pageType === 'product' && data.product) {
    var p = data.product;
    gtrack('view_item', {
      currency: currency,
      value: p.price,
      items: [{
        item_id: String(p.id),
        item_name: p.title,
        item_brand: p.vendor,
        item_category: p.type,
        item_variant: p.variantTitle !== 'Default Title' ? p.variantTitle : '',
        item_list_name: p.collections && p.collections.length ? p.collections[0] : '',
        price: p.price,
        quantity: 1
      }]
    });
  }

  // Collection page: view_item_list is fired by sections/main-collection.liquid

  // Article page
  if (data.pageType === 'article' && data.article) {
    var a = data.article;
    gtrack('view_article', {
      article_id: String(a.id),
      article_title: a.title,
      article_author: a.author,
      blog_name: a.blog,
      article_tags: (a.tags || []).join(', '),
      published_at: a.publishedAt
    });
  }

  // Cart page
  if (data.pageType === 'cart' && data.cart) {
    var cart = data.cart;
    gtrack('view_cart', {
      currency: currency,
      value: cart.totalPrice,
      items: (cart.items || []).map(function (item) {
        return {
          item_id: String(item.id),
          item_name: item.title,
          item_variant: item.variantTitle !== 'Default Title' ? item.variantTitle : '',
          price: item.price,
          quantity: item.quantity
        };
      })
    });
  }

  // Homepage
  if (data.pageType === 'index') {
    gtrack('view_homepage', {});
  }

  // Custom pages
  if (data.pageType === 'page' && data.page) {
    gtrack('view_page', {
      page_title: data.page.title,
      page_handle: data.page.handle
    });
  }

  // Search page: 'search' is fired by sections/main-search.liquid

  // Blog listing page
  if (data.pageType === 'blog' && data.blog) {
    gtrack('view_blog', {
      blog_name: data.blog.title,
      articles_count: data.blog.articlesCount
    });
  }


  // ── CART SNAPSHOT (so begin_checkout carries value/items from the drawer too) ──
  var cartSnapshot = null;
  function mapCartItems(c) {
    return (c.items || []).map(function (it) {
      return {
        item_id: String(it.variant_id),
        item_name: it.product_title,
        item_variant: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
        price: it.final_price / 100,
        quantity: it.quantity
      };
    });
  }
  function refreshCartSnapshot() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartSnapshot = c; })
      .catch(function () {});
  }
  refreshCartSnapshot();
  document.documentElement.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.items) cartSnapshot = e.detail.cart;
  });

  // ── ADD TO CART ─────────────────────────────────────────────────────────────
  // The theme fires 'variant:add' with the items that were actually added (add.js response),
  // then 'cart:change'. The calculator only fires 'cart:change', so it uses the fallback below.
  var lastAddAt = 0;
  document.addEventListener('variant:add', function (e) {
    var added = e.detail && e.detail.items;
    if (!added || !added.length) return;
    lastAddAt = Date.now();
    var items = added.map(function (it) {
      return {
        item_id: String(it.variant_id),
        item_name: it.product_title || it.title,
        item_brand: it.vendor || '',
        item_variant: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
        item_category: it.product_type || '',
        price: it.final_price / 100,
        quantity: it.quantity
      };
    });
    gtrack('add_to_cart', {
      currency: currency,
      value: items.reduce(function (n, i) { return n + i.price * i.quantity; }, 0),
      items: items
    });
  });

  document.documentElement.addEventListener('cart:change', function (e) {
    if (!e.detail) return;

    if (e.detail.baseEvent === 'variant:add' && Date.now() - lastAddAt > 1500) {
      var cartData = e.detail.cart;
      if (cartData && cartData.items && cartData.items.length) {
        var item = cartData.items[0];
        gtrack('add_to_cart', {
          currency: cartData.currency || currency,
          value: item.final_line_price / 100,
          items: [{
            item_id: String(item.variant_id),
            item_name: item.product_title,
            item_brand: item.vendor || '',
            item_variant: item.variant_title !== 'Default Title' ? item.variant_title : '',
            item_category: item.product_type || '',
            price: item.final_price / 100,
            quantity: item.quantity
          }]
        });
      }
    }

    if (e.detail.baseEvent === 'variant:remove' && data.pageType !== 'cart') {
      var removeCart = e.detail.cart;
      gtrack('remove_from_cart', {
        currency: removeCart ? (removeCart.currency || currency) : currency
      });
    }
  });


  // ── BEGIN CHECKOUT ──────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[name="checkout"], a[href="/checkout"]');
    if (!el) return;
    var checkoutData = { currency: currency };
    if (cartSnapshot) {
      checkoutData.value = cartSnapshot.total_price / 100;
      checkoutData.items = mapCartItems(cartSnapshot);
    }
    gtrack('begin_checkout', checkoutData);
  });


  // ── CART DRAWER OPEN ────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[aria-controls="cart-drawer"], .header__icon--cart, #cart-icon-bubble');
    if (trigger) gtrack('cart_drawer_open', {});
  });


  // ── SEARCH DRAWER OPEN ──────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[aria-controls="search-drawer"], .header__icon--search, [data-drawer="search"]');
    if (trigger) gtrack('search_drawer_open', {});
  });


  // ── PREDICTIVE SEARCH RESULT CLICK ─────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var result = e.target.closest('.predictive-search__item-result, .predictive-search__products a, .predictive-search__suggestions a');
    if (!result) return;
    var title = result.querySelector('h3, h4, .product-title');
    gtrack('search_result_click', {
      result_text: title ? title.textContent.trim() : result.textContent.trim().slice(0, 100)
    });
  });


  // ── NEWSLETTER SIGNUP / NOTIFY-ME ───────────────────────────────────────────
  // Shopify's {% form 'customer' %} adds a hidden form_type=customer input.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'customer' || !form.querySelector('input[type="email"]')) return;
    if (form.classList.contains('notify-form')) {
      gtrack('notify_me_signup', { item_name: data.product ? data.product.title : '' });
    } else {
      gtrack('newsletter_signup', { form_location: form.id || 'unknown' });
    }
  });


  // ── CONTACT FORM SUBMIT ─────────────────────────────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/contact') !== -1 && !form.querySelector('input[name="form_type"][value="customer"]')) {
      gtrack('contact_form_submit', { page_handle: data.page ? data.page.handle : '' });
    }
  });


  // ── FAQ EXPANDED ────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('details summary');
    if (!summary) return;
    var details = summary.closest('details');
    if (details && !details.open) {
      gtrack('faq_expanded', { question: summary.textContent.trim().slice(0, 100) });
    }
  });


  // ── PRODUCT VARIANT SELECTED ────────────────────────────────────────────────
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.hasAttribute('data-option-position')) return;
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    gtrack('select_variant', {
      item_name: data.product ? data.product.title : '',
      item_id: data.product ? String(data.product.id) : '',
      option_name: input.name || '',
      option_value: label ? label.textContent.trim() : input.value
    });
  });


  // ── PRODUCT CARD CLICK (home / featured / anywhere except collection + related) ──
  // main-collection.liquid and related-products.liquid fire their own select_item.
  document.addEventListener('click', function (e) {
    if (data.pageType === 'collection') return;
    var link = e.target.closest('product-card a[href*="/products/"]');
    if (!link || link.closest('product-recommendations, recently-viewed-products')) return;
    var card = link.closest('product-card');
    var section = link.closest('section[id], [id^="shopify-section"]');
    gtrack('select_item', {
      item_list_name: section ? section.id.replace('shopify-section-', '') : data.pageType,
      items: [{ item_id: card ? card.getAttribute('handle') : '', item_name: card ? card.getAttribute('handle') : '' }]
    });
  });


  // ── NAVIGATION CLICK ────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('header nav a, .header__menu-item, .header__submenu a');
    if (link) {
      gtrack('navigation_click', {
        link_text: link.textContent.trim(),
        link_url: link.href || ''
      });
    }
  });


  // ── BANNER / SLIDESHOW CTA CLICK ────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.slideshow .button, .banner .button, .hero .button, .image-with-text__link');
    if (cta) {
      gtrack('banner_cta_click', {
        link_text: cta.textContent.trim(),
        link_url: cta.href || ''
      });
    }
  });


  // ── VIDEO PLAY ──────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var video = e.target.closest('video-media');
    if (!video) return;
    var section = video.closest('section[id], [id^="shopify-section"]');
    gtrack('video_play', { section_id: section ? section.id : '' });
  });


  // ── BLOG POST CLICK ─────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.blog-post-card');
    if (!link) return;
    var title = link.querySelector('h2, h3, h4, .h4, .h5');
    gtrack('blog_post_click', {
      article_title: title ? title.textContent.trim() : '',
      article_url: link.href || '',
      blog_name: data.blog ? data.blog.title : ''
    });
  });


  // ── RELATED / RECENTLY VIEWED PRODUCT CLICK ─────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('product-recommendations a[href*="/products/"], recently-viewed-products a[href*="/products/"]');
    if (!link) return;
    var card = link.closest('product-card');
    gtrack('recommended_product_click', {
      recommendation_type: link.closest('product-recommendations') ? 'related' : 'recently_viewed',
      item_name: card ? card.getAttribute('handle') : '',
      source_product: data.product ? data.product.title : ''
    });
  });


  // ── FOOTER LINK CLICK ───────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('footer a');
    if (link) {
      gtrack('footer_link_click', {
        link_text: link.textContent.trim(),
        link_url: link.href || ''
      });
    }
  });


  // ── ANNOUNCEMENT BAR CLICK ──────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.announcement-bar a, .announcement-bar__link, .ticker a');
    if (link) {
      gtrack('announcement_click', {
        link_text: link.textContent.trim(),
        link_url: link.href || ''
      });
    }
  });

})();
